import {
  AudioLines,
  Blocks,
  Bot,
  Brain,
  Building2,
  ChartNoAxesColumn,
  FileDiff,
  Files,
  FileText,
  Gamepad2,
  CalendarDays,
  GitPullRequest,
  GitPullRequestArrow,
  Globe2,
  Goal,
  Inbox,
  Layers3,
  LayoutDashboard,
  MessageSquarePlus,
  MusicIcon,
  Palette,
  PanelsTopLeft,
  Send,
  Settings,
  ShieldCheck,
  Smartphone,
  SquareKanban,
  SquareTerminal,
  Store,
  Users,
  Wrench,
} from "lucide-react";
import type { ComponentProps } from "react";

/**
 * A workroom's glyph by its registry key (2026-09-03, with the Calendar
 * board): the board chips under Sessions and the "+" menu's board entries
 * read one map so a board looks the same at both seats. Unknown keys wear
 * the generic board glyph — a new board never renders blank.
 */
export function WorkroomIcon({
  workroomKey,
  ...props
}: { readonly workroomKey: string } & ComponentProps<typeof LayoutDashboard>) {
  switch (workroomKey) {
    case "games":
      return <Gamepad2 {...props} />;
    case "mobile-app":
      return <Smartphone {...props} />;
    case "designer":
      return <Palette {...props} />;
    case "delegation-gates":
    case "platform-admin":
      return <ShieldCheck {...props} />;
    case "websites":
      return <Globe2 {...props} />;
    case "calendar":
      return <CalendarDays {...props} />;
    case "music":
      return <MusicIcon {...props} />;
    case "boomgik":
      return <AudioLines {...props} />;
    case "kanban":
      return <SquareKanban {...props} />;
    case "commerce":
    case "commercial-operations":
      return <Store {...props} />;
    case "tools":
      return <Wrench {...props} />;
    // Can 77 (Platform Admin, Rooms lists every kind): the rest of the built-in kinds, each the glyph its registry row
    // names (backend/convex/lib/boardRegistry.js), so no built-in Workroom wears the generic glyph.
    case "goals":
      return <Goal {...props} />;
    case "preview":
      return <Globe2 {...props} />;
    case "terminal":
      return <SquareTerminal {...props} />;
    case "files":
      return <Files {...props} />;
    case "file":
      return <FileText {...props} />;
    case "diff":
      return <FileDiff {...props} />;
    case "pull-request":
      return <GitPullRequest {...props} />;
    case "pull-requests":
      return <GitPullRequestArrow {...props} />;
    case "agents":
      return <Bot {...props} />;
    case "member":
      return <Layers3 {...props} />;
    case "inbox":
      return <Inbox {...props} />;
    case "world-commerce":
      return <Store {...props} />;
    case "world-members":
      return <Users {...props} />;
    case "models":
      return <Brain {...props} />;
    case "settings":
      return <Settings {...props} />;
    case "usage":
      return <ChartNoAxesColumn {...props} />;
    case "sub-session":
      return <MessageSquarePlus {...props} />;
    case "workrooms":
      return <PanelsTopLeft {...props} />;
    case "media":
      return <Send {...props} />;
    case "crm":
      return <Building2 {...props} />;
    case "components":
      return <Blocks {...props} />;
    default:
      return <LayoutDashboard {...props} />;
  }
}

export { workroomAccentVariable } from "../workroomAccent";
